var map = {
	"./attack_direction.png": "yC2W",
	"./attack_direction_dark.png": "dZRU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pzf5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/attack_direction.*\.png$
// module id = Pzf5
// module chunks = 94